module.exports = __webpack_public_path__ + "img/kv.8524ab40.png";